import RELAY_FUTURE_ADDED_VALUE from "constants/RelayFutureAddedValue";
import exhaustiveStringArray from "formfn-shared/dist/utils/array/exhaustiveStringArray";
import NotificationType_enum from "types/relay/NotificationType_enum";

const NOTIFICATION_TYPES: Array<NotificationType_enum> =
  exhaustiveStringArray<NotificationType_enum>()(
    "AirdropCompleted",
    "AirdropGiftReceived",
    "BidderAuctionAlmostOver",
    "BidderAuctionExtended",
    "BidderAuctionSettled",
    "BidderClaimPnft",
    "BidderClaimPnftReminder",
    "BidderLostAuction",
    "BidderOutbid",
    "BidderWonAuction",
    "BonkClaim",
    "BuyerOfferAccepted",
    "BuyerOfferExpired",
    "CampaignApproved",
    "CampaignCommunityNewUpdateShared",
    "CampaignAddedAsTeamMember",
    "CampaignFollowersCampaignPublished",
    "CampaignGoalReachedXPercent",
    "CampaignRejected",
    "CampaignRejectedWithFeedback",
    "CollabRequest",
    "CreatorSecondarySale",
    "FollowerAuctionAlmostOver",
    "FollowerNewEditionsListed",
    "FollowerNewPieceListed",
    "FollowerNewPieceListedSecondary",
    "FollowerNewPieceScheduled",
    "FollowerScheduledAuctionIsLive",
    "InviteReceived",
    "InvitesConvertedToCreator",
    "InvitesInviteeAcceptedInvite",
    "NewFollower",
    "OwnerAuctionEnded",
    "OwnerAuctionEndedNoBids",
    "OwnerAuctionExtended",
    "OwnerAuctionSettled",
    "OwnerEditionSold",
    "OwnerEditionsSoldOut",
    "OwnerFirstBidReceived",
    "OwnerGenerativeMintSoldOut",
    "OwnerOfferReceived",
    "OwnerOtherBidReceived",
    "OwnerPieceSoldAsInstantSale",
    "PnftDropClosed",
    "UnlockableDeclinedToSharedInfo",
    "UnlockableInfoShared",
    "UnlockableShareInfo",
    "VotingApproved",
    "VotingBrokeGuidelines",
    "VotingDuplicate",
    "VotingRejected",
    RELAY_FUTURE_ADDED_VALUE
  );

export default NOTIFICATION_TYPES;
